import { defineFcm } from '../shared/factory';

export const FCM_PLATFORM_FRAUD_EMAIL_DOMAINS = defineFcm('platform_fraud_email_domains')
	.asString()
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'monorail',
		context: 'monorail',
		description:
			'Used in the signature verification process to block automated verification of signatures from known bad email domains. Comma-separated list of email domains.',
	});
